import SibLogger from './loggers/SibLogger';
import BingLogger from './loggers/BingLogger';
import BingJSLogger from './loggers/BingJSLogger';
import GoogleLogger from './loggers/GoogleLogger';
import MgmLogger from './loggers/MgmLogger';

class AdPlacement {
  constructor(placementId, placementIdx, kwCount) {
    this.placementId = placementId;
    this.placementIdx = placementIdx;
    this.kwCount = kwCount || 5; // count of keywords per ad block
    this.isMounted = false;
    this.logger = null;
  }

  initLogger(adType, adInstance) {
    switch (adType) {
      case 'bing':
        this.logger = new BingLogger(adInstance.doc, adInstance.win, adInstance, this.placementId);
        this.logger.debug('Initialized Bing Logger');
        break;
      case 'bingJS':
        /* eslint-disable-next-line */
        this.logger = new BingJSLogger(adInstance.doc, adInstance.win, adInstance, this.placementId);
        this.logger.debug('Initialized Bing JS Logger');
        break;
      case 'afs':
      case 'grs':
        /* eslint-disable-next-line */
        this.logger = new GoogleLogger(adInstance.doc, adInstance.win, adInstance, this.placementId);
        this.logger.debug('Initialized Google Logger');
        break;
      case 'mgm':
        this.logger = new MgmLogger(adInstance.doc, adInstance.win, adInstance, this.placementId);
        this.logger.debug('Initialized MGM Logger');
        break;
      case 'sib':
      default:
        this.logger = new SibLogger(adInstance.doc, adInstance.win, adInstance, this.placementId);
        this.logger.debug('Initialized SIB Logger');
        break;
    }
  }

  setMountedFlag() {
    this.isMounted = true;
  }
}

export default AdPlacement;
